import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import { useContext } from "react";
import { cartContext } from "./../../Context/CartContext";
import $ from "jquery";
import { Helmet } from "react-helmet";

export default function BrandDetails({ userData }) {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'

  let { id } = useParams();
  const {
    add,
    remove,
    cartData,
    addToWishList,
    removeFromWishList,
    wishList,
    setwishList,
  } = useContext(cartContext);
  const [wishMsg, setwishMsg] = useState("");
  const [cartProducts, setcartProducts] = useState(null);
  const [brandDetails, setbrandDetails] = useState(null);

  const navigate = useNavigate();

  // set brand name to display it in Helmet title

  const brandName = `${brandDetails?.[0]?.brand?.name} Brand`;

  // Getting Products id that added previously to Cart

  let allCartID = cartData?.data?.products?.map((e) => e.product._id);

  // Getting Products id that added previously to WishList

  let allWishListId = wishList?.map((e) => e._id);

  // check if no user data => clear allCartID & allWishList variables

  if (userData === null) {
    allCartID = null;
    allWishListId = null;
  }

  // filtering products by id to get products of specific brand

  async function getBrandDetails() {
    let { data } = await axios.get(`${baseURL}/api/v1/products`, {
      params: { brand: id },
    });
    setbrandDetails(data.data);
  }

  //Add Product to Cart

  async function addProduct(id, index) {
    if (userData === null) {
      navigate("/login");
    } else {
      let response = await add(id);
      if (response !== false) {
        let idResponse = response.data.products.map((e) => e.product);
        setcartProducts(idResponse);

        // / Show Success msg:
        $(`#successMsg${index}`).fadeIn(200, () => {
          setTimeout(() => {
            $(`#successMsg${index}`).fadeOut(200);
          }, 2000);
        });
      }
    }
  }

  //  Remove Product from Cart

  async function removeProduct(id, index) {
    let response = await remove(id);
    if (response !== false) {
      let idResponse = response.data.products.map((e) => e.product);
      setcartProducts(idResponse);

      // Show Success msg:
      $(`#deleteMsg${index}`).fadeIn(200, () => {
        setTimeout(() => {
          $(`#deleteMsg${index}`).fadeOut(200);
        }, 2000);
      });
    }
  }

  // Add to Wish Lish

  async function addProductToWishList(id, index) {
    if (userData === null) {
      navigate("/login");
    } else {
      let response = await addToWishList(id);
      if (response !== false) {
        console.log(response);
        setwishList(response?.data);
        setwishMsg(response.message);
        $(`#wishAdded${index}`).fadeIn(300, () => {
          setTimeout(() => {
            $(`#wishAdded${index}`).fadeOut(300);
          }, 2000);
        });
      }
    }
  }

  // Delete from Wish List

  async function removeProductFromWishList(id, index) {
    let response = await removeFromWishList(id);
    if (response !== false) {
      console.log(response);
      setwishMsg(response.message);
      setwishList(response.data);
      $(`#wishRemoved${index}`).fadeIn(300, () => {
        setTimeout(() => {
          $(`#wishRemoved${index}`).fadeOut(300);
        }, 2000);
      });
    }
  }

  useEffect(() => {
    getBrandDetails();
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{brandName}</title>
      </Helmet>

      {/* Check if Products in this brand then display loading screen till fetching Data, if no products in this brand display no products img  */}
      {brandDetails ? (
        <section className="row py-3 mt-3">
          {brandDetails.length === 0 ? (
            ""
          ) : (
            <h2 className="text-main mb-3">
              Brand:{" "}
              <span className="text-dark fw-bold">
                {brandDetails[0].brand.name}
              </span>
            </h2>
          )}
          {brandDetails.length === 0 ? (
            <div className="text-center py-1">
              <img
                height={300}
                src={require("../../assets/images/no-products.jpg")}
                alt="No Products"
              />
              <div>
                <h2 className="h4">
                  {" "}
                  <Link
                    className="hoveringClick fw-bold fa-fade text-main"
                    style={{
                      "--fa-animation-duration": "2s",
                      "--fa-fade-opacity": 0.6,
                    }}
                    to="/"
                  >
                    Shopping Now
                  </Link>
                </h2>
              </div>
            </div>
          ) : (
            // Display products of the specific brand
            brandDetails?.map((product, index) => (
              <div key={index} className="col-md-4 col-xl-3">
                <div className="product px-2 py-3 h-100 position-relative">
                  {/* check if products in wishlist */}
                  {wishList?.includes(product._id) ||
                  allWishListId?.includes(product._id) ? (
                    // remove product from wishlist
                    <span
                      className="d-inline-block position-absolute top-0 end-0 p-1 cursor-pointer star border-0"
                      onClick={() =>
                        removeProductFromWishList(product._id, index)
                      }
                    >
                      <i className="fa-solid fa-heart text-main"></i>
                    </span>
                  ) : (
                    // add product to wishlist
                    <span
                      id={`wishAdd${index}`}
                      className=" position-absolute top-0 end-0 p-1 cursor-pointer rounded-circle Btn star border-0"
                      onClick={() => addProductToWishList(product._id, index)}
                    >
                      <i className="fa-regular fa-heart"></i>
                    </span>
                  )}

                  {/* display product img cover */}
                  <img
                    src={product?.imageCover}
                    className="w-100"
                    alt={product.title}
                  />

                  {/* link to product details */}
                  <Link to={`/productdetails/${product._id}`}>
                    <span className="look text-main bg-light rounded-3 font-sm">
                      Quick Look<i className="ms-2 fa-solid fa-expand"></i>
                    </span>
                  </Link>

                  <span className="text-main my-2 d-block">
                    {/* link to the category of this product  */}
                    <Link
                      className="text-main fw-bold hoveringClick"
                      to={`/categorydetails/${product.category._id}`}
                    >
                      {product?.category.name}
                    </Link>{" "}
                    /{" "}
                    <span className="text-dark font-sm fw-bold">
                      {product?.subcategory[0].name}
                    </span>
                  </span>

                  {/* display product title */}
                  <h3 className=" h6 fw-bolder">
                    {product?.title.split(" ").slice(0, 5).join(" ")}
                  </h3>

                  {/* display product price & rating average */}
                  <div className="d-flex justify-content-between">
                    {/* check if discount on this product or not and display the price */}
                    <p>
                      {product?.priceAfterDiscount ? (
                        <>
                          <span className=" text-decoration-line-through text-muted moderate">
                            {product?.price}
                          </span>{" "}
                          <span className=" text-muted fw-bold">
                            {product?.priceAfterDiscount}EGP
                          </span>
                        </>
                      ) : (
                        <span className="text-muted fw-bold">
                          {product?.price}EGP
                        </span>
                      )}
                    </p>

                    {/* display rating average */}
                    <p>
                      <span className="moderate">
                        {product?.ratingsAverage}{" "}
                        <i className="fas fa-star rating-color moderate"></i>{" "}
                      </span>
                    </p>
                  </div>

                  {/* Handling Success messages of add & remove from (Cart || Wishlish) */}
                  <div
                    id={`successMsg${index}`}
                    className="alert alert-success successMsg"
                    style={{ display: "none" }}
                  >
                    Product added successfully to your cart{" "}
                    <i className="me-2 fs-5 fa-regular fa-thumbs-up"></i>
                  </div>
                  <div
                    id={`deleteMsg${index}`}
                    className="alert alert-danger deleteMsg"
                    style={{ display: "none" }}
                  >
                    Product Removed successfully to your cart
                  </div>
                  <div
                    id={`wishAdded${index}`}
                    className="alert alert-success "
                    style={{ display: "none" }}
                  >
                    {wishMsg}
                    <i className="ms-2 fs-5 fa-regular fa-thumbs-up"></i>
                  </div>
                  <div
                    id={`wishRemoved${index}`}
                    className="alert alert-danger"
                    style={{ display: "none" }}
                  >
                    {wishMsg}
                  </div>

                  {/* check if products in cart */}
                  {cartProducts?.includes(product._id) ||
                  allCartID?.includes(product._id) ? (
                    // remove product from cart button
                    <button
                      id={`remove${index}`}
                      onClick={() =>
                        removeProduct(brandDetails[index]._id, index)
                      }
                      className="btn btn-outline-danger  w-100 mt-2"
                    >
                      Remove
                      <i className="ms-2 fs-5 fa-regular fa-trash-can"></i>
                    </button>
                  ) : (
                    // add product to cart button
                    <button
                      id={`add${index}`}
                      onClick={() => addProduct(brandDetails[index]._id, index)}
                      className="btn Btn w-100"
                    >
                      Add<i className="ms-2 fs-5 fa-solid fa-cart-plus"></i>
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </section>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
}
